import { Box, Container } from "@mui/material";
import React, { createContext, useState } from "react";
import { Outlet } from "react-router-dom";
import QMentisBreadCrumb from "../custom-components/QMentisBreadCrumb";

export const MultipleUserStoriesContext = createContext(null);
export const UserStoriesLoaderContext = createContext(null);

const MultipleUserStoryPage = () => {

  const [multipleUserStories, setMultipleUserStories] = useState([]);
  const [selectedUserStories, setSelectedUserStories] = useState([
    ...multipleUserStories,
  ]);
  const [multipleEvaluationSummary, setMultipleEvaluationSummary] = useState(
    []
  );
  const [multipleRefinedUserStory, setMultipleRefinedUserStory] = useState([]);
  const [selectedRefinedUserStories, setSelectedRefinedUserStories] = useState([
    ...multipleRefinedUserStory,
  ]);
  const [multipleUseCases, setMultipleUseCases] = useState([]);
  const [selectedUseCases, setSelectedUseCases] = useState([
    ...multipleUseCases,
  ]);

  const [userStoryLoaderState, setUserStoryLoaderState] = useState(null);

  const breadCrumbs = [
    {
      title: "Input Details",
      status: multipleUserStories.length > 0 ? "Completed" : "In Progress",
    },
    {
      title: "Evaluate User Stories",
      status:
        multipleEvaluationSummary.length > 0
          ? "Completed"
          : multipleUserStories.length > 0 &&
            userStoryLoaderState === "Evaluation Summary"
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Refine User Stories",
      status:
        multipleRefinedUserStory.length > 0 &&
          multipleRefinedUserStory.length ===
          selectedUserStories.filter((eachStory) => !!eachStory).length
          ? "Completed"
          : multipleUserStories.length > 0 &&
            userStoryLoaderState === "Refined User Stories"
            ? "In Progress"
            : "Not Started",
    },

    //   {
    //     title: "Generate Use Cases",
    //     status:
    //       multipleUseCases.length === multipleUserStories.length &&
    //       multipleUserStories.length > 0
    //         ? "Completed"
    //         : multipleRefinedUserStory.length === multipleUserStories.length &&
    //           multipleUserStories.length > 0 && userStoryLoaderState === "Use Case"
    //         ? "In Progress"
    //         : "Not Started",
    //   },
  ];
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        minWidth: 0, // Important: allows flex items to shrink below content size
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", // Changed from center to stretch
        flexGrow: 1,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{
        width: "100%",
        minWidth: 0, // Important: allows shrinking
        overflow: "hidden",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
      }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0", // Adjust this value as needed to place the breadcrumb where you want it
            // width: "100%",
            zIndex: 1000, // Ensure it stays above other content
            bgcolor: "white", // Background color to prevent transparency
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Optional shadow for visual separation
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{ height: "56px" }}
          />
        </Box>

        {/* Add padding-top to avoid overlap with the fixed breadcrumb */}
        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            minHeight: "80vh",
            height: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Container
            sx={{
              width: "100%",
            }}
          >
            <UserStoriesLoaderContext.Provider
              value={{ userStoryLoaderState, setUserStoryLoaderState }}
            >
              <MultipleUserStoriesContext.Provider
                value={{
                  multipleUserStories,
                  setMultipleUserStories,
                  selectedUserStories,
                  setSelectedUserStories,
                  multipleEvaluationSummary,
                  setMultipleEvaluationSummary,
                  multipleRefinedUserStory,
                  setMultipleRefinedUserStory,
                  selectedRefinedUserStories,
                  setSelectedRefinedUserStories,
                  multipleUseCases,
                  setMultipleUseCases,
                  selectedUseCases,
                  setSelectedUseCases,
                }}
              >
                <Outlet />
              </MultipleUserStoriesContext.Provider>
            </UserStoriesLoaderContext.Provider>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default MultipleUserStoryPage;
